import { Spinner } from "react-bootstrap";

const AppLoader = ({ variant = "primary" }) => {
  return (
    <div className="fs-14 app-loader">
      <Spinner animation="border" variant={variant} size="sm" />
    </div>
  );
};

export default AppLoader;
